import { Component, Panel, Table } from "@mcleod/components";
import { DesignerDataSource } from "../DesignerDataSource";
import { UIDesigner } from "../UIDesigner";

export class ActionDeleteComponent {
  component: Component;
  designer: UIDesigner;
  index: number;

  constructor(component) {
    this.component = component;
  }

  execute() {
    if (!(this.component.parent instanceof Table) || !this.component.parent._handleSpecialDelete(this.component)) {
      this.index = this.component.parent.indexOf(this.component);
      this.component.parent.remove(this.component);
    }
    if (this.component instanceof DesignerDataSource) {
      const tab = this.designer.getActiveTab();
      delete tab.dataSources[this.component.designerDataSource.id];
    }
    this.designer.selectComponent(null);
  }

  undo() {
    if (this.component.parent instanceof Panel) {
      this.component.parent.insert(this.component, this.index);
      this.designer.selectComponent(this.component);
    }
    else
      this.component.parent.add(this.component);
  }

  toString() {
    return "Delete " + this.component.constructor.name;
  }
}
